import { Button, Card, CardContent, CardHeader, Divider, Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";
import { useActivateSim } from "./hook/useActivateSim";
import { pukCodeRegex } from "@utils/formControl";
import { Loader } from "@common/Loader/Loader";

export const ActivateSim = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { formMethods, validationCodeState, handleSubmit } = useActivateSim(setIsModalOpen);
    const { error, isLoading } = validationCodeState;
    const { t } = useTranslation(["sim", "common", "glossary", "validation"]);

    const closeModal = () => setIsModalOpen(false);

    const { errors, register } = formMethods;

    return (
        <Card className="activateSim" elevation={2}>
            <CardHeader
                style={{ paddingBottom: "10px" }}
                title={t("sim:activateReplacementSim")}
                titleTypographyProps={{ variant: "h2", color: "primary", align: "center" }}
            />
            <Divider light style={{ marginBottom: "10px" }} variant="middle" />
            <CardContent>
                <Typography align="center" gutterBottom={Boolean(error)} variant="normal">
                    {t("sim:activateReplacementSimHelperText")}
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Grid container justifyContent="center" spacing={2}>
                        <Grid item md={7} sm={11} xs={12}>
                            <TextField
                                error={Boolean(errors.activationCode)}
                                fullWidth
                                helperText={errors.activationCode?.message}
                                id="activationCode"
                                inputRef={register({
                                    required: t("validation:required"),
                                    validate: pukCodeRegex,
                                })}
                                label={t("sim:enterPuk")}
                                margin="dense"
                                name="activationCode"
                                type="text"
                            />
                        </Grid>
                        {error && (
                            <Grid item xs={12}>
                                <Typography align="center" color="error" gutterBottom>
                                    {error.errorMessage || t("common:genericError")}
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Grid container justifyContent="center">
                                {isLoading && <Loader size={40} />}
                                {!isLoading && (
                                    <Button color="primary" size="large" type="submit" variant="contained">
                                        {t("sim:activateSim")}
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
                <Modal
                    close={closeModal}
                    confirm={closeModal}
                    confirmLabel={t("glossary:close")}
                    isModalOpen={isModalOpen}
                    title={t("glossary:happyDays")}
                >
                    <Typography align="center" variant="normal">
                        {t("sim:activateSimSuccess")}
                    </Typography>
                </Modal>
            </CardContent>
        </Card>
    );
};
